
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import pc from './pc/estadisticas.vue';
    import movil from './movil/estadisticas.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: { pc, movil }
    } )
    export default class Componente extends Vue
    {
        mounted()
        {
            if ( !this.$vuetify.breakpoint.xsOnly )
            {
                this.$router.replace( '/preguntas/landscape' );
            }
        }

    }
